module.exports = __webpack_public_path__ + "static/img/science_technology_intensity_2.6ca4618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/science_technology_intensity_2.png
// module id = +q1h
// module chunks = 6